import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Contact = () => {
  return (
    <div className="bg-white">
      {/* Header Section */}
      <div className="bg-slate-900 py-16 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]"></div>
        </div>
        <div className="container mx-auto px-6 lg:px-12 relative z-10 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-extrabold text-white mb-6 uppercase tracking-tight"
          >
            Projekt <span className="text-red-500">anfragen</span>
          </motion.h1>
          <motion.div 
            initial={{ scaleX: 0 }} 
            animate={{ scaleX: 1 }} 
            className="w-20 h-1.5 bg-red-800 rounded-full mx-auto mb-8"
          ></motion.div>
          <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto font-light">
            Wir beraten Sie gerne fachmännisch bei Ihrem Bauvorhaben.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          
          {/* Kontakt-Informationen */}
          <div className="lg:col-span-5">
            <h2 className="text-3xl font-bold text-slate-900 mb-8">Kontaktinfo</h2>
            <div className="space-y-8">
              {[
                { icon: FiMapPin, label: "Adresse", value: "Bachstraße 7, 91785 Pleinfeld / Mischelbach" },
                { icon: FiPhone, label: "Telefon", value: "0151 / 744 658 32", link: "tel:015174465832" },
                { icon: FiMail, label: "E-Mail", value: "Info@Kittsteiner-Bau.de", link: "mailto:Info@Kittsteiner-Bau.de" }
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-5">
                  <div className="w-12 h-12 bg-slate-100 text-red-800 rounded-xl flex items-center justify-center flex-shrink-0">
                    <SafeIcon icon={item.icon} className="text-xl" />
                  </div>
                  <div>
                    <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">{item.label}</p>
                    {item.link ? (
                      <a href={item.link} className="text-lg text-slate-700 font-bold hover:text-red-800 transition-colors">
                        {item.value}
                      </a>
                    ) : (
                      <p className="text-lg text-slate-700 font-bold">{item.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Formular-Bereich mit Iframe - Optimiert gegen Scrollleisten */}
          <div className="lg:col-span-7">
            <div className="bg-slate-50 rounded-[2rem] border border-slate-100 overflow-hidden shadow-inner flex items-center justify-center min-h-[700px]">
              <div className="w-full overflow-hidden flex justify-center">
                <iframe 
                  src="https://share.deftform.com/ILRKOK" 
                  width="100%" 
                  height="750px" 
                  frameBorder="0" 
                  scrolling="no"
                  style={{ 
                    border: 'none', 
                    overflow: 'hidden',
                    transform: 'scale(0.98)',
                    transformOrigin: 'top center'
                  }}
                  title="Kontaktformular"
                  className="w-full max-w-full"
                >
                  Wird geladen...
                </iframe>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;